import { RIGHTS } from './catalog';
import { Rule, allOf, anyOf, full, notRestrictedAtAllBy, visible } from './levels';

// Actions de la fiche client et extraction : mêmes règles que l'API (src/Security/Rights/RouteRights.php),
// pour masquer ce que le serveur refuserait
export const CUSTOMER_ACTIONS = {
  movePoints: anyOf(visible(RIGHTS.customer.changeAccount), visible(RIGHTS.admin.batchs)),
  addManualTransaction: anyOf(
    visible(RIGHTS.customer.addManualTransaction),
    visible(RIGHTS.customer.addManualTransactionPage),
    visible(RIGHTS.admin.batchs),
  ),
  changeStore: anyOf(visible(RIGHTS.customer.changeStore), visible(RIGHTS.store.batchChange), visible(RIGHTS.admin.batchs)),
  extract: allOf(visible(RIGHTS.query.extract), notRestrictedAtAllBy(RIGHTS.query.noExtract)),
  editDetails: visible(RIGHTS.customer.changeDetail),
  questionnaire: visible(RIGHTS.customer.changeForm),
  history: anyOf(full(RIGHTS.customer.histo), full(RIGHTS.customer.customerService)),
} satisfies Record<string, Rule>;
